import { debounce } from 'lodash-es';

/* Sticks catalogue image to top of screen when scrolling through article body text on desktop */
export default document.addEventListener('DOMContentLoaded', function () {
  // Get element to stick
  const stickyEl = document.querySelector('.js-sticky-img');

  // Get if is desktop
  const DESKTOP_BREAKPOINT = '(min-width: 768px)'; // Matches tailwind lg breakpoint
  const isDesktop = () => {
    const mediaQuery = window.matchMedia(DESKTOP_BREAKPOINT);
    return mediaQuery.matches;
  };

  // Don't run if on mobile/no sticky el
  if (!stickyEl) return;

  // Check if image is "stuck"
  let isCurrentlyStuck = false;
  function updateStuckState() {
    // Check if image top is above the top edge of the screen
    const rect = stickyEl.getBoundingClientRect();
    const shouldBeStuck = rect.top <= 0;

    // Only run once per function run to (try and) avoid the layout shift caused by the .stuck class changing the value of rect.top and causing an annoying layout thrashing(!) bug
    if (isCurrentlyStuck !== shouldBeStuck) {
      // Toggle 'stickiness' of image
      stickyEl.classList.toggle('stuck', shouldBeStuck);
      isCurrentlyStuck = shouldBeStuck;
    }
  }

  // Use lodash debounce to control scroll and resize callback
  const debouncedUpdateStuckState = debounce(() => {
    // Only run this on desktop
    if (isDesktop()) {
      updateStuckState();
    }
  }, 20);

  // Listen to scroll events to update stuck state
  window.addEventListener('scroll', debouncedUpdateStuckState);
  // Recheck on resize
  window.addEventListener('resize', debouncedUpdateStuckState);

  // Initial check on load
  updateStuckState();
});
